import { useSelector } from 'react-redux';
import IkeaLogo from '../../IkeaLogo/IkeaLogo';
import styles from './ApplicationName.module.scss';
import {
  selectCurrentLanguageCode,
  selectCurrentRetailUnit,
} from '../../../store/slices/intl';
import { Link } from 'react-router-dom';
import { trackUIInteraction } from '../../../utils/analyticsEvents';

const ApplicationName = function ApplicationName() {
  const retailUnit = useSelector(selectCurrentRetailUnit);
  const languageCode = useSelector(selectCurrentLanguageCode);
  const to = `/${retailUnit || 'ZZ'}/${languageCode || 'en'}`;

  return (
    <Link
      className={styles.componentwrapper}
      to={to}
      onClick={() => {
        trackUIInteraction('logo_click');
      }}
    >
      <IkeaLogo />
      <div className={styles.textwrapper}>
        <h1 className={styles.title}>Kategorisera</h1>
        <span className={styles.byline}>Handling of the range structure</span>
      </div>
    </Link>
  );
};

export default ApplicationName;
